import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { ArrowLeft, ArrowRight, SkipForward, Loader2 } from "lucide-react";

interface OnboardingNavigationProps {
  onBack?: () => void;
  onNext: () => void;
  onSkip?: () => void;
  canSkip: boolean;
  isFirst: boolean;
  isLast: boolean;
  loading: boolean;
  showNavigation?: boolean;
}

export default function OnboardingNavigation({
  onBack,
  onNext,
  onSkip,
  canSkip,
  isFirst,
  isLast,
  loading,
  showNavigation = true,
}: OnboardingNavigationProps) {
  const { t } = useTranslation("onboarding");

  if (!showNavigation) return null;

  return (
    <div className="space-y-3 border-t border-border pt-4">
      <div className="flex items-center justify-between">
        <div>
          {!isFirst && onBack && (
            <Button
              type="button"
              variant="ghost"
              onClick={onBack}
              disabled={loading}
              className="gap-1"
            >
              <ArrowLeft className="h-4 w-4" />
              {t("navigation.back")}
            </Button>
          )}
        </div>

        <div className="flex items-center gap-2">
          {canSkip && onSkip && (
            <Button
              type="button"
              variant="ghost"
              onClick={onSkip}
              disabled={loading}
              className="gap-1 text-muted-foreground"
            >
              <SkipForward className="h-4 w-4" />
              {t("navigation.skip")}
            </Button>
          )}

          <Button
            type="button"
            onClick={onNext}
            disabled={loading}
            className="gap-1 bg-foreground text-background hover:bg-foreground/90"
          >
            {loading ? (
              <Loader2 className="h-4 w-4 animate-spin" />
            ) : isLast ? (
              t("navigation.finish")
            ) : (
              <>
                {t("navigation.next")}
                <ArrowRight className="h-4 w-4" />
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}
